/* eslint-disable camelcase */
import i18next from 'i18next';

i18next.addResources('es_ES', 'RecaptchaDisclaimer', {
  text: 'Este sitio está protegido por reCAPTCHA y se aplican la <privacy>Política de privacidad</privacy> y los <terms>Términos del servicio</terms> de Google.'
});

i18next.addResources('pt_PT', 'RecaptchaDisclaimer', {
  text: 'Este site é protegido pelo reCAPTCHA e aplicam-se a <privacy>Política de Privacidade</privacy> e os <terms>Termos de Serviço</terms> do Google.'
});
